export const generateRandomSeed = (length: number): string => {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return [...Array(length)].map(item => chars[Math.floor(Math.random() * chars.length)]).join('');
};
